import Classes from "./Calendar.module.scss";
import {Helmet} from "react-helmet";
import React from "react";
import data from "../../assets/data/meta.json"

const year = new Date().getMonth() < 8 ? new Date().getFullYear() : new Date().getFullYear() + 1;

const MonthsNames = {
    SEPTEMBER: { number: 9, name: "Сентябрь" },
    OCTOBER: { number: 10, name: "Октябрь" },
    NOVEMBER: { number: 11, name: "Ноябрь" },
    DECEMBER: { number: 12, name: "Декабрь" },
    JANUARY: { number: 1, name: "Январь" },
    FEBRUARY: { number: 2, name: "Февраль" },
    MARCH: { number: 3, name: "Март" },
    APRIL: { number: 4, name: "Апрель" },
    MAY: { number: 5, name: "Май" },
    JUNE: { number: 6, name: "Июнь" },
    JULY: { number: 7, name: "Июль" },
    AUGUST: { number: 8, name: "Август" }
};

const redDays = [
    { day: 7, month: MonthsNames.NOVEMBER, holiday: "День Октябрьской революции" },
    { day: 25, month: MonthsNames.DECEMBER, holiday: "Рождество Христово (католическое Рождество)" },
    { day: 1, month: MonthsNames.JANUARY, holiday: "Новый год" },
    { day: 2, month: MonthsNames.JANUARY, holiday: "Новый год" },
    { day: 7, month: MonthsNames.JANUARY, holiday: "Рождество Христово (православное Рождество)" },
    { day: 8, month: MonthsNames.MARCH, holiday: "День женщин" },
    { day: 29, month: MonthsNames.APRIL, holiday: "Радуница" },
    { day: 1, month: MonthsNames.MAY, holiday: "Праздник труда" },
    { day: 9, month: MonthsNames.MAY, holiday: "День Победы" },
    { day: 3, month: MonthsNames.JULY, holiday: "День Независимости Республики Беларусь (День Республики)" }
];

function getCalendarMonthNumber(month) {
    return (month + 8) % 12
}

const daysInMonth = [
    30, 31, 30, 31, 31, 28, 31, 30, 31, 30, 31, 31
];

const weekDays = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

if ((year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)) {
    daysInMonth[1] = 29;
}

const getFirstDayInMonth = (month) => {
    const targetYear = month > 3 ? year : year - 1;
    return (new Date(targetYear, getCalendarMonthNumber(month), 1).getDay() + 6) % 7;
}

const firstDaysArray = Array.from({ length: 12 }, (_, month) => getFirstDayInMonth(month));

const weeksArray = Array.from({ length: 12 }, (_, month) => {
    return Math.ceil((firstDaysArray[month] + daysInMonth[month]) / 7);
});

const cumulativeWeeksArray = weeksArray.map((_, month) =>
    weeksArray.slice(0, month).reduce((sum, weeks) =>
        sum + weeks + (firstDaysArray[month] !== 0 ? -1 : 0), 0
    )
);

const generateCalendarData = (month) => {
    const daysInCurrentMonth = daysInMonth[month];

    const firstDay = firstDaysArray[month];

    const weeks = weeksArray[month];
    const rows = 7;

    let data = Array.from({ length: weeks }, () => Array(rows).fill(null));

    let day = 1;
    for (let week = 0; week < weeks; week++) {
        for (let row = 0; row < rows; row++) {
            if (week === 0 && row < firstDay) {
                data[week][row] = null;
            } else if (day <= daysInCurrentMonth) {
                data[week][row] = day++;
            }
        }
    }

    return data;
};

const generateWeek = (month) => {
    const weeks = weeksArray[month];
    const rows = 1;
    let data = Array.from({ length: weeks }, () => Array(rows).fill(null));

    let numOfWeek = cumulativeWeeksArray[month];
    for (let week = 0; week < weeks; week++) {
        for (let row = 0; row < rows; row++) {
            data[week][row] = numOfWeek++ % 4 + 1;
        }
    }

    return data;
};

const isCurrentWeek = (month, weekDays) => {
    return new Date().getMonth() === getCalendarMonthNumber(month) && weekDays.includes(new Date().getDate());
}

const isCurrentDay = (month, day) => {
    return new Date().getMonth() === getCalendarMonthNumber(month) && day === new Date().getDate();
}

const isRedDay = (month, day) => {
    month = getCalendarMonthNumber(month);
    const targetYear = month < 8 ? year : year - 1;
    return (redDays.some(redDay => redDay.day === day && redDay.month.number === month + 1))
        || new Date(targetYear, month, day - 1).getDay() === 6;
};

const getDayClass = (month, day) => {
    if (day === null) return `${Classes.day} ${Classes.emptyDay}`;
    if (isCurrentDay(month, day)) return `${Classes.day} ${Classes.currentDay}`;
    if (isRedDay(month, day)) return `${Classes.day} ${Classes.redDay}`;
    return Classes.day;
};

const Calendar = () => {
    return (
        <React.Fragment>
            <Helmet>
                <title>{data[18].title}</title>
                <meta name="description" content={data[18].description} />
            </Helmet>
            <div className={Classes.calendarContainer}>
                <h3 className={Classes.calendarTitle}>Календарь учебных недель {year - 1} - {year}</h3>
                <div className={Classes.calendar}>
                    {Object.values(MonthsNames).map(value => value).map((month, index) => (
                        <div className={Classes.monthContainer} key={month.number}>
                            <div className={Classes.month}>
                                <h3>{month.name}</h3>
                                <div className={Classes.monthGrid}>
                                    <div className={Classes.weekDaysColumn}>
                                        {weekDays.map((day) => (
                                            <div className={Classes.weekDay} key={day}>{day}</div>
                                        ))}
                                    </div>
                                    <div className={Classes.daysGrid} style={{ gridTemplateColumns: `repeat(${weeksArray[index]}, 1fr)` }}>
                                        {generateCalendarData(index).map((column) => (
                                            <div className={`${Classes.dayColumn} ${isCurrentWeek(index, column) ? Classes.currentWeekColumn : ""}`} key={month.name}>
                                                {column.map((day) => {
                                                    const holiday = redDays.find((redDay) =>
                                                        redDay.day === day && redDay.month.name === month.name
                                                    );
                                                    return (
                                                        <div className={getDayClass(index, day)} title={holiday ? holiday.holiday : ""} key={day}>
                                                            {day}
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                        ))}
                                    </div>
                                </div>
                                <hr className={Classes.dividerLine} />
                                <div className={Classes.weekGrid}>
                                    <div className={Classes.weekDaysColumn}>
                                        <div className={Classes.daysOfWeekHeader}>НД</div>
                                    </div>
                                    <div className={Classes.daysGrid} style={{ gridTemplateColumns: `repeat(${weeksArray[index]}, 1fr)` }}>
                                        {generateWeek(index).map((column) => (
                                            <div className={Classes.dayColumn} key={month[0]}>
                                                {column.map((day) => (
                                                    <div className={Classes.weekNum} key={day}>{day}</div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </React.Fragment>
    );
};

export default Calendar;
